import { render, staticRenderFns } from "./RPGroupMsgEffect.vue?vue&type=template&id=d04e2ab8"
import script from "./RPGroupMsgEffect.vue?vue&type=script&lang=js"
export * from "./RPGroupMsgEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports